var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRetry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.554 19.8581C16.3486 19.2214 17.8573 17.9658 18.8094 16.3167L17.9619 15.8274C17.1262 17.2748 15.8019 18.3769 14.2268 18.9357C12.6516 19.4946 10.9289 19.4736 9.36783 18.8765C7.80679 18.2794 6.50975 17.1454 5.70962 15.678C4.90948 14.2107 4.65868 12.5061 5.00225 10.8705C5.34582 9.23484 6.26124 7.77527 7.58414 6.75385C8.90704 5.73244 10.5507 5.2161 12.2201 5.29756C13.8894 5.37903 15.4751 6.05295 16.6922 7.19832C17.6291 8.07995 18.3004 9.19645 18.6433 10.4216L16.5178 9.2689L16.0178 10.1349L19.4819 12.1349L21.4819 8.67082L20.6159 8.17082L19.5466 10.0228C19.1454 8.68005 18.3958 7.45755 17.3629 6.4856C15.9762 5.18068 14.1697 4.41288 12.2678 4.32007C10.3659 4.22725 8.49323 4.81552 6.98604 5.97922C5.47886 7.14292 4.43591 8.80582 4.04449 10.6693C3.65306 12.5328 3.9388 14.4748 4.85039 16.1465C5.76199 17.8183 7.23971 19.1103 9.01821 19.7906C10.7967 20.4708 12.7595 20.4948 14.554 19.8581Z",
    fill: "#1792E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetry);
export default __webpack_public_path__ + "static/media/Retry.2c9985e71afbb2668969354697dd1387.svg";
export { ForwardRef as ReactComponent };